import React from "react";
import FinishedFlag from "./FinishedFlag";
import InProgressFlag from "./InProgressFlag";
import { useSession } from "../api/helpers";
import useIsFinished from "../sessions/useIsFinished";

interface Props {
  sessionId: number;
}

const SessionFlag = ({ sessionId }: Props) => {
  const session = useSession(sessionId);
  const isInProgress = session?.status === "InProgress";
  const isFinished = useIsFinished(sessionId);

  if (isInProgress) {
    return <InProgressFlag />;
  }

  if (isFinished) {
    return <FinishedFlag />;
  }

  return null;
};

export default SessionFlag;
